import React from 'react'

function Array() {
    return (
        <span className='cs-data-array'>Array</span>
    )
}

export { Array }